
export const isObjHasOwnProp = (obj = {}, prop = "") => {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}
